import dayjs from 'dayjs'

function check_privilege(name, options = {}) {
  let bot
  if (options.bot) {
    bot = options.bot
  } else {
    return false
  }

  let packages = getPackageType(bot)
  switch (name) {
    case 'shippop':
    case 'packhai':
    case 'akita':
    case 'sokochan':
      return (
        (packages.includes('advanced') ||
          packages.includes('premium') ||
          packages.includes('old_premium')) &&
        !packages.includes('enterprise')
      )
    case 'instagram':
      return (
        packages.includes('advanced') ||
        packages.includes('premium') ||
        packages.includes('old_premium') ||
        packages.includes('enterprise')
      )
    case 'google':
      return packages.includes('business') || packages.includes('google_message')
    case 'salepage_analytic':
    case 'multichannel':
      return (
        packages.includes('old_premium') ||
        packages.includes('advanced') ||
        packages.includes('enterprise')
      )
    case 'line':
      return (
        packages.includes('old_premium') ||
        packages.includes('premium') ||
        packages.includes('advanced') ||
        packages.includes('enterprise')
      )
    case 'whatsapp':
      return packages.includes('business') || packages.includes('whatsapp_message')
    case 'line_shopping':
    case 'connect_line':
      return packages.includes('advanced') || packages.includes('enterprise')
    case 'connect_whatsapp':
      return (
        packages.includes('business') ||
        packages.includes('enterprise') ||
        packages.includes('whatsapp_message')
      )
    case 'allin1chat':
      return (
        (packages.includes('enterprise') &&
          options.livechatPageList &&
          options.livechatPageList.includes(bot.theme)) ||
        (options.livechatPageIdList && options.livechatPageIdList.includes(bot.pageid)) ||
        (bot.theme == 'ecommercebasic' && bot.pageid == '270028443161479') ||
        packages.includes('advanced') ||
        window.aston.astonpages.includes(bot.pageid) ||
        packages.includes('allin1chat')
      )
    case 'vat':
      return (
        ['998122266996445', '134182372147489', '623635804423191'].includes(bot.pageid) &&
        (packages.includes('premium') ||
          packages.includes('advanced') ||
          packages.includes('enterprise'))
      )
    case 'event_conversion':
      return packages.includes('advanced')
  }

  return false
}

function getPackageType(bot) {
  let now = dayjs()
  let premium = {
    date: null,
    time: 0
  }
  premium.date = dayjs(bot.expireat)
  premium.time = parseInt(premium.date.diff(now, 'seconds'))

  let advanced = {
    date: null,
    time: 0
  }
  advanced.date = dayjs(bot.advanced_expireat)
  advanced.time = parseInt(advanced.date.diff(now, 'seconds'))

  let allin1chat = {
    date: null,
    time: 0
  }

  allin1chat.date = dayjs(bot.livechat_expireat)
  allin1chat.time = parseInt(allin1chat.date.diff(now, 'seconds'))

  let business = {
    date: null,
    time: 0
  }

  business.date = dayjs(bot.business_expireat)
  business.time = parseInt(business.date.diff(now, 'seconds'))

  let google_message = {
    date: null,
    time: 0
  }
  let whatsapp_message = {
    date: null,
    time: 0
  }

  google_message.date = dayjs(bot.google_message_expireat)
  google_message.time = parseInt(google_message.date.diff(now, 'seconds'))
  whatsapp_message.date = dayjs(bot.whatsapp_expireat)
  whatsapp_message.time = parseInt(whatsapp_message.date.diff(now, 'seconds'))
  let packages = []
  if (business.time > 0) packages.push('business')
  if (advanced.time > 0) packages.push('advanced')
  if (premium.time > 0 && bot.privilege_type == 'BEFORE_ADVANCED') packages.push('old_premium')
  else if (premium.time > 0) packages.push('premium')
  if (allin1chat.time > 0) packages.push('allin1chat')
  if (bot.pagetype === 'enterprise') packages.push('enterprise')
  if (google_message.time > 0) packages.push('google_message')
  if (whatsapp_message.time > 0) packages.push('whatsapp_message')
  return packages
}

export { check_privilege, getPackageType }



// WEBPACK FOOTER //
// ./src/privileges.js